import { RootState } from '@store/rootReducer'

/**
 * Sparse, index-aligned with the photoshoot card grid; entries are either the
 * generated image (string) or `null` (still loading / failed).
 *
 * Consumers that need a "ready-only" array or a `hasResults` boolean should
 * derive them with `useMemo` at the call site to keep this slice's API surface
 * minimal and avoid unused selectors.
 */
export const selectPhotoshootResults = (state: RootState) => state.photoshoot.results

export const selectPhotoshootDiscardRequested = (state: RootState) =>
  state.photoshoot.discardRequested

/**
 * `true` while the photoshoot run is generating results. Read by the global
 * Navbar to disable the Settings button during loading.
 */
export const selectPhotoshootIsGenerating = (state: RootState) =>
  state.photoshoot.isGenerating

/**
 * The product image uploaded on the form step (`blob:` URL) or `null`. Persisted
 * in the slice so it survives a remount of the route-level `Photoshoots`
 * component when navigating back from the run step.
 */
export const selectPhotoshootUploadedImage = (state: RootState) =>
  state.photoshoot.uploadedImageUrl
